import { User } from '@dcs-libs/shared';

export interface TopUsers {
  users: User[];
  values?: number[];
}
